import { t } from '../../i18n'
import type { MessageKey } from '../../i18n'
import type { LiveStatus } from '../../live/events'

const LABELS: Record<LiveStatus, MessageKey> = {
  connecting: 'inbox.live.connecting',
  live: 'inbox.live.live',
  stalled: 'inbox.live.stalled',
  offline: 'inbox.live.offline',
}

/**
 * Whether what is on screen is still arriving.
 *
 * Small and quiet while it works, and impossible to miss when it does not: a
 * manager who thinks the inbox is live when it froze ten minutes ago will read
 * silence as "no new messages".
 */
export function LiveIndicator({ status }: { readonly status: LiveStatus }) {
  const label = t(LABELS[status])

  return (
    <span className={`live live--${status}`} title={label}>
      <span className="live__dot" aria-hidden="true" />
      <span className="live__label">{label}</span>
    </span>
  )
}
